import { render, staticRenderFns } from "./videoRecording.vue?vue&type=template&id=6add38a7&scoped=true"
import script from "./videoRecording.vue?vue&type=script&lang=js"
export * from "./videoRecording.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6add38a7",
  null
  
)

export default component.exports